import React, { useState, useEffect, useContext } from "react";
import { ThemeContext } from "styled-components";

/* import utils */
import { NotifyContext } from "./../../util/notify";

/* import services */
import api from "./../../services/api";

import { useTheme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Chip from "@material-ui/core/Chip";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Checkbox from "@material-ui/core/Checkbox";

/* import components */
import Input from "./../../components/Form/Input";
import Select from "./../../components/Form/Select";

/* import icons */
import IncomeIcon from "./../../assets/icons/income";

import {
  Container,
  Cards,
  Card,
  Title,
  Subtitle,
  Comment,
  AddButton,
  FormModal,
  FormGroup,
  HorariosContainer,
  HorarioChip,
  DatasContainer,
  DataInput,
  RegrasContainer,
  CheckboxContainer,
  CheckboxLabel,
} from "./styles";

const setorOptions = [
  { value: "", text: "Todos os setores" },
  { value: "Secretaria e Cadastro", text: "Secretaria e Cadastro" },
  { value: "Financeiro", text: "Financeiro" },
  { value: "Jurídico", text: "Jurídico" },
  { value: "Fiscalização", text: "Fiscalização" },
];

const horariosPadrao = ["08:00", "09:00", "10:00", "11:00", "13:00", "14:00", "15:00", "16:00"];

function ConfigAgendamento({ toggleTitles }) {
  toggleTitles("Configurações de Agendamento", "Parametrização de horários e datas bloqueadas");

  const { status: colors } = useContext(ThemeContext);
  const { notify } = useContext(NotifyContext);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [sedes, setSedes] = useState([]);

  const [titleModal, setTitleModal] = useState("Nova Configuração");
  const [id, setId] = useState("");
  const [sede_id, setSedeId] = useState("");
  const [setor_destino, setSetorDestino] = useState("");
  const [horarios_disponiveis, setHorariosDisponiveis] = useState([...horariosPadrao]);
  const [novoHorario, setNovoHorario] = useState("");
  const [datas_bloqueadas, setDatasBloqueadas] = useState([]);
  const [novaDataBloqueada, setNovaDataBloqueada] = useState("");
  const [bloquear_fins_semana, setBloquearFinsSemana] = useState(true);
  const [limite_por_horario, setLimitePorHorario] = useState(1);
  const [ativo, setAtivo] = useState(true);

  const handleClearForm = event => {
    event.preventDefault();
    setTitleModal("Nova Configuração");
    setId("");
    setSedeId("");
    setSetorDestino("");
    setHorariosDisponiveis([...horariosPadrao]);
    setNovoHorario("");
    setDatasBloqueadas([]);
    setNovaDataBloqueada("");
    setBloquearFinsSemana(true);
    setLimitePorHorario(1);
    setAtivo(true);
  };

  const handleNewData = () => {
    handleClearForm({ preventDefault: () => {} });
    setModalOpen(true);
  };

  const handleOpenModalEdit = async config => {
    setTitleModal("Editar Configuração");
    setId(config.id);
    setSedeId(config.sede_id || "");
    setSetorDestino(config.setor_destino || "");
    setHorariosDisponiveis(config.horarios_disponiveis || [...horariosPadrao]);
    setDatasBloqueadas(config.datas_bloqueadas || []);
    setBloquearFinsSemana(config.regras_especiais?.bloquear_fins_semana !== false);
    setLimitePorHorario(config.regras_especiais?.limite_por_horario || 1);
    setAtivo(config.ativo !== false);
    setModalOpen(true);
  };

  const handleAddHorario = () => {
    if (novoHorario && !horarios_disponiveis.includes(novoHorario)) {
      setHorariosDisponiveis([...horarios_disponiveis, novoHorario]);
      setNovoHorario("");
    }
  };

  const handleRemoveHorario = horario => {
    setHorariosDisponiveis(horarios_disponiveis.filter(h => h !== horario));
  };

  const handleAddDataBloqueada = () => {
    if (novaDataBloqueada && !datas_bloqueadas.includes(novaDataBloqueada)) {
      setDatasBloqueadas([...datas_bloqueadas, novaDataBloqueada]);
      setNovaDataBloqueada("");
    }
  };

  const handleRemoveDataBloqueada = data => {
    setDatasBloqueadas(datas_bloqueadas.filter(d => d !== data));
  };

  const handleSave = async event => {
    event.preventDefault();
    try {
      const regras_especiais = {
        bloquear_fins_semana: bloquear_fins_semana,
        limite_por_horario: parseInt(limite_por_horario),
      };

      const payload = {
        sede_id: sede_id || null,
        setor_destino: setor_destino || null,
        horarios_disponiveis,
        datas_bloqueadas,
        regras_especiais,
        ativo,
      };

      if (!id) {
        await api.post(`/config_agendamentos`, payload);
        notify.show(true, "Configuração adicionada com sucesso", "success");
      } else {
        await api.put(`/config_agendamentos/${id}`, payload);
        notify.show(true, "Configuração atualizada com sucesso", "success");
      }

      loadData();
      setModalOpen(false);
    } catch (error) {
      console.log(error);
      notify.show(true, "Erro ao salvar configuração! Tente novamente", "error");
    }
  };

  const handleDelete = async configId => {
    if (window.confirm("Tem certeza que deseja excluir esta configuração?")) {
      try {
        await api.delete(`/config_agendamentos/${configId}`);
        notify.show(true, "Configuração excluída com sucesso", "success");
        loadData();
      } catch (error) {
        console.log(error);
        notify.show(true, "Erro ao excluir configuração! Tente novamente", "error");
      }
    }
  };

  async function loadData() {
    try {
      const { data: sedesData } = await api.get("/sede");
      setSedes(sedesData.map(s => ({ value: s.id, text: s.name })));

      const { data } = await api.get("/config_agendamentos/panel");
      // Ordena: primeiro por sede (null por último), depois por setor (null por último)
      const sortedData = data.sort((a, b) => {
        // Configurações globais (sem sede) vão por último
        if (!a.sede_id && b.sede_id) return 1;
        if (a.sede_id && !b.sede_id) return -1;

        // Se ambas têm sede, ordena por nome da sede
        if (a.sede_id && b.sede_id) {
          const nomeA = a.sede?.name || "";
          const nomeB = b.sede?.name || "";
          if (nomeA !== nomeB) return nomeA.localeCompare(nomeB);

          // Mesma sede: configurações gerais (sem setor) vêm antes das específicas
          if (!a.setor_destino && b.setor_destino) return -1;
          if (a.setor_destino && !b.setor_destino) return 1;

          // Ambas têm setor ou ambas não têm: ordena por nome do setor
          const setorA = a.setor_destino || "";
          const setorB = b.setor_destino || "";
          return setorA.localeCompare(setorB);
        }

        return 0;
      });
      setData(sortedData);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <Container>
        <Cards>
          {data.map(config => {
            const sedeName = config.sede ? config.sede.name : "Todas as sedes";
            const setorName = config.setor_destino || "Todos os setores";
            const horariosCount = config.horarios_disponiveis?.length || 0;
            const datasCount = config.datas_bloqueadas?.length || 0;
            const status = config.ativo ? "active" : "inactive";
            const isGeralSede = config.sede_id && !config.setor_destino;
            const isEspecificoSetor = config.sede_id && config.setor_destino;
            const isGlobal = !config.sede_id && !config.setor_destino;

            return (
              <Card
                status={colors[status]}
                key={config.id}>
                <div style={{ width: "100%", position: "relative" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
                    <div style={{ flex: 1 }}>
                      <Title style={{ margin: 0, marginBottom: "8px" }}>
                        {sedeName}
                        {isEspecificoSetor && <span style={{ fontSize: "14px", fontWeight: "normal", display: "block", marginTop: "4px" }}>{setorName}</span>}
                      </Title>
                      <div style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
                        {isGeralSede && (
                          <Chip
                            label="Geral da Sede"
                            size="small"
                            color="primary"
                            style={{ fontSize: "10px", height: "20px" }}
                          />
                        )}
                        {isEspecificoSetor && (
                          <Chip
                            label="Específico do Setor"
                            size="small"
                            color="secondary"
                            style={{ fontSize: "10px", height: "20px" }}
                          />
                        )}
                        {isGlobal && (
                          <Chip
                            label="Global"
                            size="small"
                            style={{ fontSize: "10px", height: "20px", backgroundColor: "#9e9e9e", color: "white" }}
                          />
                        )}
                      </div>
                    </div>

                  </div>

                  {isGeralSede && (
                    <Comment style={{ fontStyle: "italic", color: "#862019", marginBottom: "10px", fontSize: "11px" }}>
                      Aplica-se a todos os setores desta sede quando não houver configuração específica
                    </Comment>
                  )}
                  {isEspecificoSetor && (
                    <Comment style={{ fontStyle: "italic", color: "#862019", marginBottom: "10px", fontSize: "11px" }}>
                      Configuração específica para este setor (sobrescreve a configuração geral da sede)
                    </Comment>
                  )}

                  <div style={{ marginTop: "12px", borderTop: "1px solid #f0f0f0", paddingTop: "12px", flex: 1 }}>
                    <Comment style={{ marginBottom: "6px", fontSize: "12px", fontWeight: "500" }}>
                      {horariosCount} horário(s) disponível(is)
                    </Comment>
                    <Comment style={{ marginBottom: "6px", fontSize: "12px" }}>
                      {datasCount} data(s) bloqueada(s)
                    </Comment>
                    {config.regras_especiais?.bloquear_fins_semana !== false && (
                      <Comment style={{ marginBottom: "4px", fontSize: "11px", color: "#862019" }}>
                        ✓ Bloqueio de fins de semana ativo
                      </Comment>
                    )}
                    {config.regras_especiais?.limite_por_horario && (
                      <Comment style={{ fontSize: "11px", color: "#862019" }}>
                        ✓ Limite: {config.regras_especiais.limite_por_horario} por horário
                      </Comment>
                    )}
                  </div>
                  <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <button onClick={() => handleOpenModalEdit(config)} style={{  backgroundColor: "blue", color: "white", border: "none", cursor: "pointer", padding: "10px", borderRadius: "5px", marginTop: "10px" }}>Editar Configuração</button>
                  <button onClick={() => handleDelete(config.id)} style={{  backgroundColor: "red", color: "white", border: "none", cursor: "pointer", padding: "10px", borderRadius: "5px", marginTop: "10px" }}>
                    Remover Configuração
                  </button></div>
                </div>
              </Card>
            );
          })}
        </Cards>

        <AddButton onClick={() => handleNewData()}>
          <IncomeIcon /> Nova Configuração
        </AddButton>
      </Container>

      <Dialog
        fullScreen={fullScreen}
        open={modalOpen}
        onClose={event => {
          handleClearForm(event);
          setModalOpen(false);
        }}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth>
        <DialogTitle id="responsive-dialog-title">{titleModal}</DialogTitle>
        <DialogContent>
          <div style={{ marginBottom: "20px", padding: "10px", backgroundColor: "#f5f5f5", borderRadius: "4px" }}>
            <strong style={{ color: "#862019" }}>Como funciona a hierarquia:</strong>
            <ul style={{ marginTop: "10px", marginBottom: "0", paddingLeft: "20px", fontSize: "13px" }}>
              <li>
                <strong>Configuração específica por setor:</strong> Sede + Setor selecionados - tem prioridade mais alta
              </li>
              <li>
                <strong>Configuração geral da sede:</strong> Sede selecionada + "Todos os setores" - aplica-se quando não há configuração específica
              </li>
              <li>
                <strong>Configuração global:</strong> "Todas as sedes" + "Todos os setores" - padrão quando não há outras configurações
              </li>
            </ul>
          </div>
          <FormModal onSubmit={handleSave} autoComplete="off">
            <FormGroup>
              <Select
                id="sede_id"
                name="sede_id"
                label="Sede"
                options={[{ value: "", text: "Todas as sedes (Global)" }, ...sedes]}
                initialValue={sede_id}
                onChange={value => {
                  console.log(value);
                  setSedeId(value);
                  // Se selecionou "Todas as sedes", limpa o setor
                  if (!value) {
                    setSetorDestino("");
                  }
                }}
              />

              <Select
                id="setor_destino"
                name="setor_destino"
                label="Setor"
                options={setorOptions}
                initialValue={setor_destino}
                onChange={value => {
                  if(sede_id) {
                    setSetorDestino(value);
                  }
                  else {
                    setSetorDestino("");
                  }
                }}
              />
            </FormGroup>
            {!sede_id && (
              <div style={{ marginBottom: "15px", padding: "8px", backgroundColor: "#ffebee", borderRadius: "4px", fontSize: "13px", color: "#c62828" }}>
                ⚠️ Selecione uma sede primeiro para habilitar a seleção de setor
              </div>
            )}
            {sede_id && !setor_destino && (
              <div style={{ marginBottom: "15px", padding: "8px", backgroundColor: "#e3f2fd", borderRadius: "4px", fontSize: "13px" }}>
                ℹ️ Esta será uma <strong>configuração geral da sede</strong>. Ela será usada para todos os setores desta sede que não tiverem configuração específica.
              </div>
            )}
            {sede_id && setor_destino && (
              <div style={{ marginBottom: "15px", padding: "8px", backgroundColor: "#fff3e0", borderRadius: "4px", fontSize: "13px" }}>
                ℹ️ Esta será uma <strong>configuração específica do setor</strong>. Ela terá prioridade sobre a configuração geral da sede.
              </div>
            )}

            <FormGroup>
              <div style={{ width: "100%" }}>
                <label style={{ marginBottom: "10px", display: "block", color: "#707070" }}>Horários Disponíveis</label>
                <HorariosContainer>
                  {horarios_disponiveis.map(horario => (
                    <Chip
                      key={horario}
                      label={horario}
                      onDelete={() => handleRemoveHorario(horario)}
                      color="primary"
                      style={{ margin: "5px" }}
                    />
                  ))}
                </HorariosContainer>
                <div style={{ display: "flex", marginTop: "10px" }}>
                  <Input
                    id="novoHorario"
                    name="novoHorario"
                    label="Novo Horário (HH:MM)"
                    type="text"
                    initialValue={novoHorario}
                    onChange={text => setNovoHorario(text)}
                    style={{ flex: 1, marginRight: "10px" }}
                  />
                  <Button variant="outlined" onClick={handleAddHorario} style={{ marginTop: "25px" }}>
                    Adicionar
                  </Button>
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div style={{ width: "100%" }}>
                <label style={{ marginBottom: "10px", display: "block", color: "#707070" }}>Datas Bloqueadas</label>
                <DatasContainer>
                  {datas_bloqueadas.map(data => (
                    <Chip
                      key={data}
                      label={data}
                      onDelete={() => handleRemoveDataBloqueada(data)}
                      color="secondary"
                      style={{ margin: "5px" }}
                    />
                  ))}
                </DatasContainer>
                <div style={{ display: "flex", marginTop: "10px" }}>
                  <Input
                    id="novaDataBloqueada"
                    name="novaDataBloqueada"
                    label="Nova Data Bloqueada (YYYY-MM-DD)"
                    type="date"
                    initialValue={novaDataBloqueada}
                    onChange={text => setNovaDataBloqueada(text)}
                    style={{ flex: 1, marginRight: "10px" }}
                  />
                  <Button variant="outlined" onClick={handleAddDataBloqueada} style={{ marginTop: "25px" }}>
                    Adicionar
                  </Button>
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <RegrasContainer>
                <CheckboxContainer>
                  <Checkbox
                    id="bloquear_fins_semana"
                    checked={bloquear_fins_semana}
                    onChange={e => setBloquearFinsSemana(e.target.checked)}
                    color="primary"
                  />
                  <CheckboxLabel htmlFor="bloquear_fins_semana">Bloquear fins de semana</CheckboxLabel>
                </CheckboxContainer>

                <Input
                  id="limite_por_horario"
                  name="limite_por_horario"
                  label="Limite de agendamentos por horário"
                  type="number"
                  initialValue={limite_por_horario}
                  onChange={text => setLimitePorHorario(text)}
                  style={{ maxWidth: "200px" }}
                />
              </RegrasContainer>
            </FormGroup>

            <FormGroup>
              <CheckboxContainer>
                <Checkbox
                  id="ativo"
                  checked={ativo}
                  onChange={e => setAtivo(e.target.checked)}
                  color="primary"
                />
                <CheckboxLabel htmlFor="ativo">Ativo</CheckboxLabel>
              </CheckboxContainer>
            </FormGroup>

            <button id="btnFormSubmit" style={{ display: "none" }}>
              enviar
            </button>
          </FormModal>
        </DialogContent>

        <DialogActions>
          <Button
            tabIndex={111}
            onClick={event => {
              handleClearForm(event);
              setModalOpen(false);
            }}
            color="secondary">
            Cancelar
          </Button>
          <Button tabIndex={110} color="primary" onClick={() => document.querySelector("#btnFormSubmit").click()}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ConfigAgendamento;

